
<template>
  <div>

    <v-container fluid>
      <v-row dense>
        <v-col
          v-for="system in sortedList"
          :key="system.id"
          cols="12"
          xs="12"
          sm="6"
          md="3"
        >
          <v-card
            width="300px"
            hover
            shaped
          >
            <v-img
              :src="getImgUrl(system.code + '.png')"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1) 50%, rgba(0,0,0,.7)"
              height="100px"
            >
            </v-img>

            <v-card-text>
              <div>{{system.game.start_time | moment("Do MMMM YYYY HH:mm")}}</div>
              <p class="display-1 text--primary">
                {{system.game.track.track_name}}
              </p>
              <p>{{system.reduced_size}} rader (av {{system.original_size}})</p>
              <div class="text--primary">
                {{system.date | fromNow}}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" outlined @click="openSystem(system.id)">
                <v-icon>mdi-open</v-icon>
                Öppna
              </v-btn>
              <v-btn text>Klona</v-btn>
              <v-btn text>Radera</v-btn>
            </v-card-actions>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      systems: []
    }
  },

  mounted () {
    const that = this
    const systemsParams = { email: this.$store.state.user.user.email }
    this.fetchSystemsAction(systemsParams).then(function () {
      that.systems = that.$store.state.systems.systems
    })
  },

  methods: {
    ...mapActions(['fetchSystemsAction']),
    openSystem (id) {
      this.$router.push({ path: `/systems/${id}` })
    },
    getImgUrl (pic) {
      return require('@/assets/' + pic)
    }
  },

  computed: {
    sortedList () {
      return [...this.systems].sort(function (item1, item2) {
        const date1 = new Date(item1.date)
        const date2 = new Date(item2.date)
        return date2 - date1
      })
    }
  }
}
</script>
